import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filter-chips-bar',
  standalone: true,
  imports: [],
  templateUrl: './filter-chips-bar.component.html',
  styleUrls: ['./filter-chips-bar.component.scss'],
})
export class FilterChipsBarComponent {
  @Input() chips: { key: string; label: string; value: string }[] = [];
  @Output() clearChip = new EventEmitter<string>();
  @Output() clearAll = new EventEmitter<void>();
}
